"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteFile = deleteFile;
exports.getPublicFileList = getPublicFileList;
exports.uploadFile = uploadFile;
var _request = _interopRequireDefault(require("@/utils/request"));
function getPublicFileList(token, form) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/files/public/list',
    method: 'post',
    headers,
    data: form
  });
}
function uploadFile(token, fileData) {
  const headers = {
    'Authorization': 'Bearer ' + token,
    'Content-Type': 'multipart/form-data'
  };
  return (0, _request.default)({
    url: '/files/public',
    method: 'post',
    data: fileData,
    headers
  });
}
function deleteFile(token, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: '/files/public',
    method: 'delete',
    data,
    headers
  });
}